var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArt00(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 184.7",
    style: {
      enableBackground: "new 0 0 1920 184.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1172.9,102.5C578.9,237.5,227.5,152.2,0,122.1l0,152l0,110.7h1920V274V2.5C1920,2.5,1734.7-25.1,1172.9,102.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt00);
export default __webpack_public_path__ + "static/media/art00.82f0bd9dc447bd79feae1c96b14a0fc7.svg";
export { ForwardRef as ReactComponent };